// extracted by mini-css-extract-plugin
export default {"wrapper":"Sharing_wrapper__zCpPl","content":"Sharing_content__gmIvn","info":"Sharing_info__ueY5o","title":"Sharing_title__fQYCv","text":"Sharing_text__gxybM"};